// URL Filters
const extractHashQueries = (hash_query: string) => {
    // Split query to seperate parameters with delimiter &
    // ex: brand=abb+fanuc

    let queries = [];
    if(hash_query.split("filter?")[1] != undefined)
        queries = hash_query.split("filter?")[1].split("&");
    let search_params = {};

    queries.map((q) => {
        // Split queries by = to retrieve name and value
        let q_set = q.split("=");

        if(q_set[1] == undefined)
            q_set[1] = ""

        if(q_set[0] != "")
            search_params[q_set[0]] = q_set[1];
    });

    return search_params;
};

const extractParamSets = (key, value) => {
    let valid_param_keys = ["name"].concat(Object.keys(window.Configs.filters));
    let extracted_param_sets = {};
    let param_key = key.toLowerCase();

    if (valid_param_keys.includes(param_key)) {
        extracted_param_sets[param_key] = convertParameter(
            key,
            value,
            param_key == "name" ? "string" : window.Configs.filters[param_key]["type"]
        );
    }

    return extracted_param_sets;
};

const convertParameter = (key, value, type) => {
    switch (key) {
        case "name":
            return value.trim().toLowerCase()

        default:
            if (type == "checkbox") {
                return value.trim().toLowerCase().split(" ")
                .map((entry) => entry.replaceAll("-", " "));
            }

            else if (type == "range") {
                return value.trim().split("-")
            }
    }
};

// Retrieve url filters and extract params
let extracted_params = {};
const extractUrlQueryOnMessage = (hash: string) => {
    if (!window.Settings.LOCAL_BUILD) {
        window.location.hash = hash;
    }

    if (window.location.hash != "") {
        let hash_params = extractHashQueries(window.location.hash);

        for (const key in hash_params) {
            let temp_params = {};

            temp_params = extractParamSets(
                key,
                hash_params[key].split("+").join(" ")
            );

            if (Object.keys(temp_params).length > 0)
                extracted_params = Object.assign(extracted_params, temp_params);
        }
    }

    return extracted_params;
};

export {
    extracted_params,
    extractUrlQueryOnMessage,
}